var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nh-button",class:{disabled: _vm.disabled, active: _vm.active},attrs:{"title":_vm.hint}},[_c('div',[_vm._v("┌─"+_vm._s(_vm.buttonEdge)+"─┐")]),_c('div',{staticClass:"nh-click",on:{"click":_vm.clickButton}},[_vm._v("│ "+_vm._s(_vm.label)+" │")]),_c('div',[_vm._v("└─"+_vm._s(_vm.buttonEdge)+"─┘")])])
}
var staticRenderFns = []

export { render, staticRenderFns }